export const REDUCER_NAME = "homeHighlightsSection";
export const SET_ERROR = `${REDUCER_NAME}/SET_ERROR`;
export const SET_HOMEHIGHLIGHTS = `${REDUCER_NAME}/SET_HOMEHIGHLIGHTS`;
